import { c as _c } from "react/compiler-runtime";
import { useSourceAccounts } from '@/contexts/useSourceAccounts';
import { AccountIndicator } from './accountIndicator';
export const SourceAccountIndicator = t0 => {
  const $ = _c(9);
  const {
    providerAccountId,
    showCloudIndicator: t1,
    showAccountName: t2,
    showAccountId: t3,
    copyable: t4
  } = t0;
  const showCloudIndicator = t1 === undefined ? true : t1;
  const showAccountName = t2 === undefined ? true : t2;
  const showAccountId = t3 === undefined ? true : t3;
  const copyable = t4 === undefined ? true : t4;
  const {
    sourceAccounts
  } = useSourceAccounts();
  let t5;
  if ($[0] !== providerAccountId || $[1] !== sourceAccounts) {
    t5 = sourceAccounts?.find(a => a.providerAccountId === providerAccountId);
    $[0] = providerAccountId;
    $[1] = sourceAccounts;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const account = t5;
  let t6;
  if ($[3] !== account || $[4] !== copyable || $[5] !== showAccountId || $[6] !== showAccountName || $[7] !== showCloudIndicator) {
    t6 = account ? <AccountIndicator account={account} showCloudIndicator={showCloudIndicator} showAccountName={showAccountName} showAccountId={showAccountId} copyable={copyable} /> : null;
    $[3] = account;
    $[4] = copyable;
    $[5] = showAccountId;
    $[6] = showAccountName;
    $[7] = showCloudIndicator;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};